const Promo = () => {
    return (
        <div className="container"  >
            <div className="row">
                <div className="col-md-6 my-5" align="center">
                    <h2>Descarga gratis este regalo especial de fe y amor en familia!</h2>
                </div>
                <div className="col-md-6" align="center">
                    <img src="/img/comunion.png" alt="Comunion" />
                </div>
            </div>
            <div className="row my-5">
                <div className="col-md-6" align="center">
                    <img src="/img/comunion2.png" />
                </div>
                <div className="col-md-2">
                </div>
                <div className="col-md-4">
                    <form action="https://amandacalem.com/server/email.php" method="post" target="_blank">
                        <h3>Quieres descargar tu contenido adicional?</h3>
                        <p>¡Hola! Soy Amanda, enviame tus datos y te respondere con un regalo especial.</p>
                        <input type="text" className="form-control my-2" placeholder="Nombre" name="name" required />
                        <input type="email" className="form-control my-2" placeholder="Email" name="email" required />
                        <div className="form-group my-2">
                            <input type="checkbox" className="form-check-input" name="terms" required />
                            <label className="form-check-label">Acepto las condiciones de uso y el aviso legal de esta web.</label>
                        </div>
                        <div className="form-group my-2" align="center">
                            <button type="submit" className="btn btn-primary btn-lg">Descargar</button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="row my-5">
                <ul>
                    <li ><b>Páginas para colorear</b> con dibujos dulces y religiosos (Jesús, ángeles, cáliz, frases de fé).</li>
                    <li ><b>Reflexiones Familiares</b> para fortalecer el vínculo con Dios y entre vosotros.</li>
                    <li ><b>Manualidades fáciles:</b> Señaladores y tarjetas de agradecimiento a los invitados.</li>
                    <li ><b>Prábolas adaptadas</b> para niños.</li>
                    <li ><b>Tarjetas "Habla con Jesús"</b> para que tu hija exprese lo que siente y ore con libertad.</li>
                </ul>
            </div>
        </div>);
};

export default Promo;